import {getTestProps} from '@benchling/js-test-utils';
import {css, StyleSheet} from 'aphrodite';
import React, {useEffect, useState} from 'react';

import {LLMShimmerText} from 'llm/loading/LLMShimmer';
import * as Colors from 'ui-library/Colors';
import BenchlingDuotoneIcon from 'ui-library/icons/BenchlingDuotoneIcon';

export function LLMSpinner(): JSX.Element {
  return (
    <BenchlingDuotoneIcon
      icon="spinner-third"
      primaryColor={Colors.PURPLE_DARK}
      secondaryColor={Colors.PURPLE_LIGHTER}
      spin={true}
    />
  );
}

interface LLMLoadingMessageProps {
  text: string | Array<string>;
  fontSize?: number;
  delay?: number;
}

export default function LLMLoadingMessage(props: LLMLoadingMessageProps): JSX.Element {
  const {text, delay = 3000} = props;
  const isArray = Array.isArray(text);
  const textArray = isArray ? text : [text];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!isArray || textArray.length <= 1) {
      return;
    }

    const lastIndex = textArray.length - 1;
    if (currentIndex >= lastIndex) {
      return;
    }

    const interval = setInterval(() => {
      setCurrentIndex((prev) => {
        const nextIndex = prev + 1;
        if (nextIndex >= lastIndex) {
          clearInterval(interval);
          return lastIndex;
        }
        return nextIndex;
      });
    }, delay);

    return () => {
      clearInterval(interval);
    };
  }, [isArray, textArray.length, currentIndex, delay]);

  const displayText = textArray[currentIndex] || '';

  return (
    <div
      className={css(styles.loadingContainer)}
      {...getTestProps({component: 'LLMLoadingMessage', element: 'root'})}
    >
      <LLMSpinner />
      <LLMShimmerText
        fontSize={props.fontSize}
        {...getTestProps({component: 'LLMLoadingMessage', element: 'shimmerText'})}
      >
        {displayText}
      </LLMShimmerText>
    </div>
  );
}

const styles = StyleSheet.create({
  loadingContainer: {
    alignItems: 'center',
    display: 'flex',
    gap: 8,
  },
});
